module.exports = __webpack_public_path__ + "static/media/wood-shield-whitespace.36abe6dc.png";